<ng-container *ngIf="dashboards && templates; else loading">
  <ul class="nav level-2" *ngIf="!selectedDashboards?.size">
    <span class="sm-flex sm-items-center sm-font-medium sm-px-2 sm-mr-auto">Dashboards</span>

    <li class="nav-item sm-mr-2" *ngIf="companyId">
      <cc-flowsite-banner templateName="power-bi-and-excel-for-analytics-tab" [companyId]="companyId"></cc-flowsite-banner>
    </li>

    <li class="nav-item" *ngIf="canAdd">
      <a
        data-cy="create-dashboard"
        class="nav-link nav-btn-success"
        routerLink="./new"
        ccSegmentCTA="Dashboard Add"
      >
        <span i18n>Add dashboard</span>
      </a>
    </li>
  </ul>
  
  <ul class="nav level-2" *ngIf="selectedDashboards?.size">
    <li class="nav-item" *ngIf="selectedDashboards?.size === 1">
      <a
        [routerLink]="['./', selectedDashboards.keys().next().value]"
        class="nav-link sm-items-center sm-space-x-1"
        (click)="clearSelection()"
        ><i class="cc-icon cc-icon-pencil"></i><span>Edit Dashboard</span></a
      >
    </li>

    <li class="nav-item" *ngIf="canAdd">
      <a class="nav-link sm-items-center sm-space-x-1" (click)="deleteSelectedDashboards()"
        ><i class="cc-icon cc-icon-delete"></i><span>Delete</span></a
      >
    </li>
  </ul>

  <ng-container *ngIf="dashboards.length; else empty">
    <div class="content">
      <div class="container grid-container">
        <cc-document
          *ngFor="let dashboard of dashboards"
          class="animate-fade-in corner"
          [selected]="selectedDashboards.get(dashboard._id)"
          (onClick)="onDashboardClick(dashboard._id)"
          (onSelectionToggle)="onSelectionToggle(dashboard, $event)"
          [displaySelectionCheckbox]="canAdd"
        >
          <div class="document-header">
            <div class="title">{{ dashboard.name }}</div>
            <div class="subtitle">{{ dashboard.chartsCount }} charts</div>
          </div>
          <div class="document-body">
            <div *ngFor="let chart of dashboard.charts" class="row no-gutters chart-row">
              <div class="col-2 icon my-auto">
                <i
                  class="cc-icon"
                  [class.cc-icon-chart-quantity]="chart.kind === chartTypes.Quantity"
                  [class.cc-icon-chart-frequency]="chart.kind === chartTypes.Frequency"
                  [class.cc-icon-chart-ratio]="chart.kind === chartTypes.Ratio"
                >
                </i>
              </div>
              <div class="col name my-auto">
                {{ chartUtilsService.getChartName(chart) || 'Untitled Chart' }}
              </div>
            </div>
            <div *ngIf="dashboard.chartsCount > chartsSampleSize" class="button-container">
              <a class="link">More...</a>
            </div>
          </div>
        </cc-document>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-template #empty>
  <div class="empty-dashboards" *ngIf="!canAdd; else createFirstDashboard">
    <img src="/assets/images/analytics/dashboard-inactive-background.svg" alt="" />
    <h3
      data-test="can-not-add-dash-empty-message"
      class="dashboard-title h3 sm-mt-6"
      i18n
    >
      No Dashboards have been created yet.
    </h3>
    <div class="text-center mt-3">
      <a
        href="https://intercom.help/dashpivot/en/articles/2563238-analytics"
        target="_blank"
        class="btn cc-btn-subtle-dark-gray"
      >
        <i class="cc-icon cc-icon-question"></i> <span>Learn more</span>
      </a>
    </div>
  </div>
</ng-template>

<ng-template #createFirstDashboard>
  <div class="empty-dashboards" *ngIf="templates?.length; else noTemplates">
    <img src="/assets/images/analytics/dashboard-active-background.svg" alt="" />
    <h3 data-test="create-first-dashboard-empty-message" class="h3 mt-4 dashboard-title" i18n>
      Create your first Dashboard
    </h3>
    <p class="default-paragraph text-center mt-2" *ngIf="companyId" i18n>
      Once a Dashboard is created, you can add charts to the Dashboard. <br />
      Charts can help visualise the form data recorded in the Templates section of each Team
    </p>
    <p class="default-paragraph text-center mt-2" *ngIf="teamId" i18n>
      Once a Dashboard is created, you can add charts to the Dashboard.<br />
      Charts can help visualise the form data recorded in the Templates section
    </p>
    <div class="text-center mt-3">
      <a
        routerLink="./new"
        data-cy="create-dashboard"
        class="btn cc-btn-primary-constructive mr-2"
        ccSegmentCTA="Dashboard Add"
        ><i class="cc-icon cc-icon-plus"></i> <span>Add dashboard</span></a
      >
      <a
        href="https://intercom.help/dashpivot/en/articles/2563238-analytics"
        target="_blank"
        class="btn cc-btn-subtle-dark-gray"
      >
        <i class="cc-icon cc-icon-question"></i> <span>Learn more</span>
      </a>
    </div>
  </div>
</ng-template>

<ng-template #noTemplates>
  <div class="empty-dashboards">
    <img src="/assets/images/analytics/dashboard-inactive-background.svg" alt="" />
    <h3 data-test="no-templates-empty-message" class="h3 mt-4 dashboard-title" i18n>
      Dashboards cannot be created yet
    </h3>
    <p class="default-paragraph text-center mt-2" *ngIf="companyId" i18n>
      You need to go to the template library, to create and deploy <br />
      at least one template before you can create a dashboard
    </p>
    <p class="default-paragraph text-center mt-2" *ngIf="teamId" i18n>
      You need to go to the templates section and add at least <br />
      one template before you can create a dashboard
    </p>
    <div class="text-center mt-3">
      <a
        href="https://intercom.help/dashpivot/en/articles/2563238-analytics"
        target="_blank"
        data-cy="create-dashboard"
        class="btn cc-btn-subtle-dark-gray"
      >
        <i class="cc-icon cc-icon-question"></i> <span>Learn more</span>
      </a>
    </div>
  </div>
</ng-template>

<ng-template #loading>
  <div class="loading-spinner">
    <div class="cc-icon cc-icon-spinner-3x"></div>
  </div>
</ng-template>

<router-outlet></router-outlet>
